import React from 'react'
import useStyles from './styles'

const SelectedRectangle = props => {
  const classes = useStyles()
  return <span className={classes.rectangle} {...props} />
}

export default SelectedRectangle
